export default "__VITE_ASSET__DBACjxcQ__"